module.exports = __webpack_public_path__ + "media/data_tables/sort_asc-6c56b94f.png";